import { memo } from 'react'
import { useScrollIntoView } from 'hooks/useScrollIntoView'

import TtsVelocityValue from './Value'
import { TTS_VELOCITY_OPTIONS } from '../../consts'

interface IProps {
  selectedValue: number | string
  handleValueClick: (value: number) => void
}

const TtsVelocityOptions: React.FC<IProps> = (props: IProps) => {
  const { selectedValue, handleValueClick } = props
  const { setNode } = useScrollIntoView()

  const getIsSelectedValue = (value: number) => value === selectedValue

  return (
    <>
      {TTS_VELOCITY_OPTIONS.map(value => (
        <TtsVelocityValue
          key={`${value}`}
          value={value}
          isSelected={getIsSelectedValue(value)}
          onClick={handleValueClick}
          setNode={setNode}
        />
      ))}
    </>
  )
}

export default memo(TtsVelocityOptions)
